// extracted by mini-css-extract-plugin
module.exports = {"item":"PageNav_item__3ww0X","current":"PageNav_current__34ebl"};